export default __webpack_public_path__ + "static/media/pricing-seven-bg.742d9697.png";